import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
// Eagerly loaded (critical path)
import { HomePage } from './pages/HomePage';
// Lazy loaded pages
const WebsiteLatenMakenPage = lazy(() => import('./pages/WebsiteLatenMakenPage').then(m => ({
  default: m.WebsiteLatenMakenPage
})));
const SeoVoorWebsitesPage = lazy(() => import('./pages/SeoVoorWebsitesPage').then(m => ({
  default: m.SeoVoorWebsitesPage
})));
const WordPressWebsitesPage = lazy(() => import('./pages/WordPressWebsitesPage').then(m => ({
  default: m.WordPressWebsitesPage
})));
const HostingOnderhoudPage = lazy(() => import('./pages/HostingOnderhoudPage').then(m => ({
  default: m.HostingOnderhoudPage
})));
const WebsiteHostingPage = lazy(() => import('./pages/WebsiteHostingPage').then(m => ({
  default: m.WebsiteHostingPage
})));
const WebsiteLatenMakenAlkmaarPage = lazy(() => import('./pages/WebsiteLatenMakenAlkmaarPage').then(m => ({
  default: m.WebsiteLatenMakenAlkmaarPage
})));
const KostenWebsiteLatenMakenPage = lazy(() => import('./pages/KostenWebsiteLatenMakenPage').then(m => ({
  default: m.KostenWebsiteLatenMakenPage
})));
const WebsiteLatenMakenChecklistPage = lazy(() => import('./pages/WebsiteLatenMakenChecklistPage').then(m => ({
  default: m.WebsiteLatenMakenChecklistPage
})));
const WebsiteLatenMakenOfZelfBouwenPage = lazy(() => import('./pages/WebsiteLatenMakenOfZelfBouwenPage').then(m => ({
  default: m.WebsiteLatenMakenOfZelfBouwenPage
})));
const WordPressVsWixPage = lazy(() => import('./pages/WordPressVsWixPage').then(m => ({
  default: m.WordPressVsWixPage
})));
const KennisbankPage = lazy(() => import('./pages/KennisbankPage').then(m => ({
  default: m.KennisbankPage
})));
const WordPressWebsiteAlkmaarPage = lazy(() => import('./pages/WordPressWebsiteAlkmaarPage').then(m => ({
  default: m.WordPressWebsiteAlkmaarPage
})));
const WordPressOnderhoudPage = lazy(() => import('./pages/WordPressOnderhoudPage').then(m => ({
  default: m.WordPressOnderhoudPage
})));
const WebsiteOnderhoudPage = lazy(() => import('./pages/WebsiteOnderhoudPage').then(m => ({
  default: m.WebsiteOnderhoudPage
})));
const WebsiteBeveiligingPage = lazy(() => import('./pages/WebsiteBeveiligingPage').then(m => ({
  default: m.WebsiteBeveiligingPage
})));
const WebsiteTipsPage = lazy(() => import('./pages/WebsiteTipsPage').then(m => ({
  default: m.WebsiteTipsPage
})));
const WebsiteVoorbeeldenPage = lazy(() => import('./pages/WebsiteVoorbeeldenPage').then(m => ({
  default: m.WebsiteVoorbeeldenPage
})));
const WebsiteMarketingPage = lazy(() => import('./pages/WebsiteMarketingPage').then(m => ({
  default: m.WebsiteMarketingPage
})));
const PortfolioPage = lazy(() => import('./pages/PortfolioPage').then(m => ({
  default: m.PortfolioPage
})));
// Sectors
const SectorZakelijkeDienstverleningPage = lazy(() => import('./pages/SectorZakelijkeDienstverleningPage').then(m => ({
  default: m.SectorZakelijkeDienstverleningPage
})));
const SectorBouwInstallatiePage = lazy(() => import('./pages/SectorBouwInstallatiePage').then(m => ({
  default: m.SectorBouwInstallatiePage
})));
const SectorMakelaarsVastgoedPage = lazy(() => import('./pages/SectorMakelaarsVastgoedPage').then(m => ({
  default: m.SectorMakelaarsVastgoedPage
})));
const SectorZorgpraktijkenPage = lazy(() => import('./pages/SectorZorgpraktijkenPage').then(m => ({
  default: m.SectorZorgpraktijkenPage
})));
const SectorHorecaHospitalityPage = lazy(() => import('./pages/SectorHorecaHospitalityPage').then(m => ({
  default: m.SectorHorecaHospitalityPage
})));
const SectorCoachesConsultantsPage = lazy(() => import('./pages/SectorCoachesConsultantsPage').then(m => ({
  default: m.SectorCoachesConsultantsPage
})));
const SectorLokaleRetailPage = lazy(() => import('./pages/SectorLokaleRetailPage').then(m => ({
  default: m.SectorLokaleRetailPage
})));
// Clusters
const ClusterAccountantPage = lazy(() => import('./pages/ClusterAccountantPage').then(m => ({
  default: m.ClusterAccountantPage
})));
const KostenWebsiteAccountantPage = lazy(() => import('./pages/KostenWebsiteAccountantPage').then(m => ({
  default: m.KostenWebsiteAccountantPage
})));
const ClusterBouwbedrijfPage = lazy(() => import('./pages/ClusterBouwbedrijfPage').then(m => ({
  default: m.ClusterBouwbedrijfPage
})));
const ClusterLoodgieterPage = lazy(() => import('./pages/ClusterLoodgieterPage').then(m => ({
  default: m.ClusterLoodgieterPage
})));
const ClusterElektricienPage = lazy(() => import('./pages/ClusterElektricienPage').then(m => ({
  default: m.ClusterElektricienPage
})));
const ClusterDakdekkerPage = lazy(() => import('./pages/ClusterDakdekkerPage').then(m => ({
  default: m.ClusterDakdekkerPage
})));
const ClusterMakelaarPage = lazy(() => import('./pages/ClusterMakelaarPage').then(m => ({
  default: m.ClusterMakelaarPage
})));
const ClusterProjectontwikkelaarPage = lazy(() => import('./pages/ClusterProjectontwikkelaarPage').then(m => ({
  default: m.ClusterProjectontwikkelaarPage
})));
const ClusterVastgoedbeheerPage = lazy(() => import('./pages/ClusterVastgoedbeheerPage').then(m => ({
  default: m.ClusterVastgoedbeheerPage
})));
const ClusterWoningpresentatiePage = lazy(() => import('./pages/ClusterWoningpresentatiePage').then(m => ({
  default: m.ClusterWoningpresentatiePage
})));
const ClusterFysiotherapiePage = lazy(() => import('./pages/ClusterFysiotherapiePage').then(m => ({
  default: m.ClusterFysiotherapiePage
})));
const ClusterTandartsPage = lazy(() => import('./pages/ClusterTandartsPage').then(m => ({
  default: m.ClusterTandartsPage
})));
const ClusterHuisartsPage = lazy(() => import('./pages/ClusterHuisartsPage').then(m => ({
  default: m.ClusterHuisartsPage
})));
const ClusterPsycholoogPage = lazy(() => import('./pages/ClusterPsycholoogPage').then(m => ({
  default: m.ClusterPsycholoogPage
})));
const ClusterRestaurantPage = lazy(() => import('./pages/ClusterRestaurantPage').then(m => ({
  default: m.ClusterRestaurantPage
})));
const ClusterHotelBbPage = lazy(() => import('./pages/ClusterHotelBbPage').then(m => ({
  default: m.ClusterHotelBbPage
})));
const ClusterCafeLunchroomPage = lazy(() => import('./pages/ClusterCafeLunchroomPage').then(m => ({
  default: m.ClusterCafeLunchroomPage
})));
const ClusterAfhaalBezorgPage = lazy(() => import('./pages/ClusterAfhaalBezorgPage').then(m => ({
  default: m.ClusterAfhaalBezorgPage
})));
const ClusterCoachingPage = lazy(() => import('./pages/ClusterCoachingPage').then(m => ({
  default: m.ClusterCoachingPage
})));
const ClusterConsultantPage = lazy(() => import('./pages/ClusterConsultantPage').then(m => ({
  default: m.ClusterConsultantPage
})));
const ClusterSportschoolPage = lazy(() => import('./pages/ClusterSportschoolPage').then(m => ({
  default: m.ClusterSportschoolPage
})));
const ClusterPersonalTrainerPage = lazy(() => import('./pages/ClusterPersonalTrainerPage').then(m => ({
  default: m.ClusterPersonalTrainerPage
})));
const ClusterKapsalonPage = lazy(() => import('./pages/ClusterKapsalonPage').then(m => ({
  default: m.ClusterKapsalonPage
})));
const ClusterFietsenwinkelPage = lazy(() => import('./pages/ClusterFietsenwinkelPage').then(m => ({
  default: m.ClusterFietsenwinkelPage
})));
const ClusterGaragePage = lazy(() => import('./pages/ClusterGaragePage').then(m => ({
  default: m.ClusterGaragePage
})));
const ClusterAutobedrijfPage = lazy(() => import('./pages/ClusterAutobedrijfPage').then(m => ({
  default: m.ClusterAutobedrijfPage
})));
// New high-intent pages
const AccountantAmsterdamPage = lazy(() => import('./pages/AccountantAmsterdamPage').then(m => ({
  default: m.AccountantAmsterdamPage
})));
const FinancieelAdviseurAmsterdamPage = lazy(() => import('./pages/FinancieelAdviseurAmsterdamPage').then(m => ({
  default: m.FinancieelAdviseurAmsterdamPage
})));
// Local pages
const WebdesignAlkmaarPage = lazy(() => import('./pages/WebdesignAlkmaarPage').then(m => ({
  default: m.WebdesignAlkmaarPage
})));
const WebdesignHeerhugowaardPage = lazy(() => import('./pages/WebdesignHeerhugowaardPage').then(m => ({
  default: m.WebdesignHeerhugowaardPage
})));
const WebdesignHoornPage = lazy(() => import('./pages/WebdesignHoornPage').then(m => ({
  default: m.WebdesignHoornPage
})));
const WebdesignSchagenPage = lazy(() => import('./pages/WebdesignSchagenPage').then(m => ({
  default: m.WebdesignSchagenPage
})));
const WebdesignDenHelderPage = lazy(() => import('./pages/WebdesignDenHelderPage').then(m => ({
  default: m.WebdesignDenHelderPage
})));
const WebdesignDijkEnWaardPage = lazy(() => import('./pages/WebdesignDijkEnWaardPage').then(m => ({
  default: m.WebdesignDijkEnWaardPage
})));
const WebdesignCastricumPage = lazy(() => import('./pages/WebdesignCastricumPage').then(m => ({
  default: m.WebdesignCastricumPage
})));
const WebdesignHeilooPage = lazy(() => import('./pages/WebdesignHeilooPage').then(m => ({
  default: m.WebdesignHeilooPage
})));
const WebdesignUitgeestPage = lazy(() => import('./pages/WebdesignUitgeestPage').then(m => ({
  default: m.WebdesignUitgeestPage
})));
const WebdesignBergenPage = lazy(() => import('./pages/WebdesignBergenPage').then(m => ({
  default: m.WebdesignBergenPage
})));
const WebdesignPurmerendPage = lazy(() => import('./pages/WebdesignPurmerendPage').then(m => ({
  default: m.WebdesignPurmerendPage
})));
const WebdesignHaarlemPage = lazy(() => import('./pages/WebdesignHaarlemPage').then(m => ({
  default: m.WebdesignHaarlemPage
})));
const WebdesignZaanstadPage = lazy(() => import('./pages/WebdesignZaanstadPage').then(m => ({
  default: m.WebdesignZaanstadPage
})));
const WebdesignHaarlemmermeerPage = lazy(() => import('./pages/WebdesignHaarlemmermeerPage').then(m => ({
  default: m.WebdesignHaarlemmermeerPage
})));
const WebdesignAmsterdamPage = lazy(() => import('./pages/WebdesignAmsterdamPage').then(m => ({
  default: m.WebdesignAmsterdamPage
})));
const WebdesignAmstelveenPage = lazy(() => import('./pages/WebdesignAmstelveenPage').then(m => ({
  default: m.WebdesignAmstelveenPage
})));
const WebdesignHilversumPage = lazy(() => import('./pages/WebdesignHilversumPage').then(m => ({
  default: m.WebdesignHilversumPage
})));
const WebdesignHuizenPage = lazy(() => import('./pages/WebdesignHuizenPage').then(m => ({
  default: m.WebdesignHuizenPage
})));
const WebdesignGooiseMerenPage = lazy(() => import('./pages/WebdesignGooiseMerenPage').then(m => ({
  default: m.WebdesignGooiseMerenPage
})));
const WebdesignVelsenPage = lazy(() => import('./pages/WebdesignVelsenPage').then(m => ({
  default: m.WebdesignVelsenPage
})));
const WebdesignBeverwijkPage = lazy(() => import('./pages/WebdesignBeverwijkPage').then(m => ({
  default: m.WebdesignBeverwijkPage
})));
const WebdesignHeemskerkPage = lazy(() => import('./pages/WebdesignHeemskerkPage').then(m => ({
  default: m.WebdesignHeemskerkPage
})));
const WebdesignTexelPage = lazy(() => import('./pages/WebdesignTexelPage').then(m => ({
  default: m.WebdesignTexelPage
})));
const WebdesignMedemblikPage = lazy(() => import('./pages/WebdesignMedemblikPage').then(m => ({
  default: m.WebdesignMedemblikPage
})));
const WebdesignEnkhuizenPage = lazy(() => import('./pages/WebdesignEnkhuizenPage').then(m => ({
  default: m.WebdesignEnkhuizenPage
})));
const WebdesignStedeBroecPage = lazy(() => import('./pages/WebdesignStedeBroecPage').then(m => ({
  default: m.WebdesignStedeBroecPage
})));
const WebdesignDrechterlandPage = lazy(() => import('./pages/WebdesignDrechterlandPage').then(m => ({
  default: m.WebdesignDrechterlandPage
})));
const WebdesignKoggenlandPage = lazy(() => import('./pages/WebdesignKoggenlandPage').then(m => ({
  default: m.WebdesignKoggenlandPage
})));
const WebdesignOpmeerPage = lazy(() => import('./pages/WebdesignOpmeerPage').then(m => ({
  default: m.WebdesignOpmeerPage
})));
const WebdesignHollandsKroonPage = lazy(() => import('./pages/WebdesignHollandsKroonPage').then(m => ({
  default: m.WebdesignHollandsKroonPage
})));
const WebdesignEdamVolendamPage = lazy(() => import('./pages/WebdesignEdamVolendamPage').then(m => ({
  default: m.WebdesignEdamVolendamPage
})));
const WebdesignWaterlandPage = lazy(() => import('./pages/WebdesignWaterlandPage').then(m => ({
  default: m.WebdesignWaterlandPage
})));
const WebdesignLandsmeerPage = lazy(() => import('./pages/WebdesignLandsmeerPage').then(m => ({
  default: m.WebdesignLandsmeerPage
})));
const WebdesignOostzaanPage = lazy(() => import('./pages/WebdesignOostzaanPage').then(m => ({
  default: m.WebdesignOostzaanPage
})));
const WebdesignWormerlandPage = lazy(() => import('./pages/WebdesignWormerlandPage').then(m => ({
  default: m.WebdesignWormerlandPage
})));
const WebdesignBloemendaalPage = lazy(() => import('./pages/WebdesignBloemendaalPage').then(m => ({
  default: m.WebdesignBloemendaalPage
})));
const WebdesignHeemstedePage = lazy(() => import('./pages/WebdesignHeemstedePage').then(m => ({
  default: m.WebdesignHeemstedePage
})));
const WebdesignZandvoortPage = lazy(() => import('./pages/WebdesignZandvoortPage').then(m => ({
  default: m.WebdesignZandvoortPage
})));
const WebdesignAalsmeerPage = lazy(() => import('./pages/WebdesignAalsmeerPage').then(m => ({
  default: m.WebdesignAalsmeerPage
})));
const WebdesignUithoornPage = lazy(() => import('./pages/WebdesignUithoornPage').then(m => ({
  default: m.WebdesignUithoornPage
})));
const WebdesignOuderAmstelPage = lazy(() => import('./pages/WebdesignOuderAmstelPage').then(m => ({
  default: m.WebdesignOuderAmstelPage
})));
const WebdesignDiemenPage = lazy(() => import('./pages/WebdesignDiemenPage').then(m => ({
  default: m.WebdesignDiemenPage
})));
const WebdesignBlaricumPage = lazy(() => import('./pages/WebdesignBlaricumPage').then(m => ({
  default: m.WebdesignBlaricumPage
})));
const WebdesignLarenPage = lazy(() => import('./pages/WebdesignLarenPage').then(m => ({
  default: m.WebdesignLarenPage
})));
const WebdesignWijdemerenPage = lazy(() => import('./pages/WebdesignWijdemerenPage').then(m => ({
  default: m.WebdesignWijdemerenPage
})));
// Other pages
const AlleLocatiesPage = lazy(() => import('./pages/AlleLocatiesPage').then(m => ({
  default: m.AlleLocatiesPage
})));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(m => ({
  default: m.NotFoundPage
})));

// Springt naar de bovenkant bij elke paginawissel.
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// De site draaide eerder op HashRouter, dus staan er nog links in de
// pagina's die als href="#/pad" zijn geschreven. Deze component vangt die
// kliks op en navigeert alsnog correct, zodat alles blijft werken zonder
// dat elk bestand aangepast hoeft te worden.
// Ankerlinks binnen een pagina, zoals #contact, blijven gewoon werken.
function LegacyHashLinks() {
  const navigate = useNavigate();
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      // Laat nieuw-tabblad en middelklik met rust
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = (event.target as HTMLElement)?.closest?.('a');
      if (!anchor) return;
      if (anchor.target && anchor.target !== '_self') return;
      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('#/')) return;
      event.preventDefault();
      navigate(href.slice(1));
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [navigate]);
  return null;
}

// Wie binnenkomt op een oude bookmark zoals /#/webdesign-alkmaar wordt
// doorgestuurd naar de schone URL /webdesign-alkmaar.
function RedirectOldHashUrls() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith('#/')) {
      const target = hash.slice(1);
      window.history.replaceState(null, '', window.location.pathname);
      navigate(target, {
        replace: true
      });
    }
  }, [navigate]);
  return null;
}

// Loading fallback
function PageLoader() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0" data-mp="3pboiww29koac">
      <div className="flex flex-col items-center gap-4" data-id="element-1" data-mp="6xxexvxwdk1q">
        <div className="w-10 h-10 border-3 border-navy-200 border-t-accent rounded-full animate-spin" data-id="element-2" data-mp="2yg8p0ancivi" />
        <p className="text-sm text-navy-400 font-medium" data-id="element-3" data-mp="gxxz1k3lc46z">Laden...</p>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4" data-mp="bz4itjwx5z34">
      <ScrollToTop data-id="element-5" data-mp="bwib9ka13jkw" />
      <LegacyHashLinks data-id="element-6" data-mp="2ip1844xu1apf" />
      <RedirectOldHashUrls data-id="element-7" data-mp="2io9g143g1v3w" />
      <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-8" data-mp="2ipksrtevad75">
        <Header data-id="element-9" data-mp="2dqrfo23hso7i" />
        <div className="flex-grow" data-id="element-10" data-mp="2dr9jpkwec6pz">
          <Suspense fallback={<PageLoader data-id="element-12" data-mp="1rx28nxkcljnp" />} data-id="element-11" data-mp="2dsawbtt2919t">
            <Routes data-id="element-13" data-mp="1rxkad9ps4q30">
              <Route path="/" element={<HomePage data-id="element-15" data-mp="1rupt1r22bldt" />} data-id="element-14" data-mp="1rw99pirmryg4" />
              <Route path="/website-laten-maken" element={<WebsiteLatenMakenPage data-id="element-17" data-mp="1wtixktzdg21u" />} data-id="element-16" data-mp="1wvlt1tjamndy" />
              <Route path="/seo-voor-websites" element={<SeoVoorWebsitesPage data-id="element-19" data-mp="26m84rcnw2trd" />} data-id="element-18" data-mp="21nwwh6d8srb9" />
              <Route path="/wordpress-websites" element={<WordPressWebsitesPage data-id="element-21" data-mp="18z80tmuyhe6w" />} data-id="element-20" data-mp="26nrlt5hdd8u7" />
              <Route path="/hosting-onderhoud" element={<HostingOnderhoudPage data-id="element-23" data-mp="1dz3yl4d289e0" />} data-id="element-22" data-mp="1dwrfgnvkfszd" />
              <Route path="/website-hosting" element={<WebsiteHostingPage data-id="element-25" data-mp="1iy738np4odlg" />} data-id="element-24" data-mp="1iv2o4va4jxg0" />
              <Route path="/website-laten-maken-alkmaar" element={<WebsiteLatenMakenAlkmaarPage data-id="element-27" data-mp="2ubja77g6pcbu" />} data-id="element-26" data-mp="1nvqhhnltsqde" />
              <Route path="/kosten-website-laten-maken" element={<KostenWebsiteLatenMakenPage data-id="element-29" data-mp="2z91dah7isxbx" />} data-id="element-28" data-mp="2uazttv66mvzx" />
              <Route path="/website-laten-maken-checklist" element={<WebsiteLatenMakenChecklistPage data-id="element-31" data-mp="inxq8km7dd59" />} data-id="element-30" data-mp="nnimgn9zn7ea" />
              <Route path="/website-laten-maken-of-zelf-bouwen" element={<WebsiteLatenMakenOfZelfBouwenPage data-id="element-33" data-mp="dvmnla02vd90" />} data-id="element-32" data-mp="ioph5i4uump7" />
              <Route path="/wordpress-vs-wix" element={<WordPressVsWixPage data-id="element-35" data-mp="3yrputbmpgvs" />} data-id="element-34" data-mp="8yw74lkd2fn2" />
              <Route path="/kennisbank" element={<KennisbankPage data-id="element-37" data-mp="3w2txrfzoiuba" />} data-id="element-36" data-mp="40kwi8m8s13s" />
              <Route path="/wordpress-website-alkmaar" element={<WordPressWebsiteAlkmaarPage data-id="element-39" data-mp="3r3hfl8jr6bf1" />} data-id="element-38" data-mp="3w2kfyfosftgo" />
              <Route path="/wordpress-onderhoud" element={<WordPressOnderhoudPage data-id="element-41" data-mp="3m5xvhs0dj4f6" />} data-id="element-40" data-mp="3r5trp52txrk6" />
              <Route path="/website-onderhoud" element={<WebsiteOnderhoudPage data-id="element-43" data-mp="1pa07y4vmhaka" />} data-id="element-42" data-mp="1pc4bumtiu9kk" />
              <Route path="/website-beveiliging" element={<WebsiteBeveiligingPage data-id="element-45" data-mp="2c7vor09ebea8" />} data-id="element-44" data-mp="1keb1dhl6qteh" />
              <Route path="/website-tips" element={<WebsiteTipsPage data-id="element-47" data-mp="277purdfnlfoz" />} data-id="element-46" data-mp="2c9f66u6sfvdl" />
              <Route path="/website-voorbeelden" element={<WebsiteVoorbeeldenPage data-id="element-49" data-mp="22gray3vghzgz" />} data-id="element-48" data-mp="279kjl2u1pryc" />
              <Route path="/website-marketing" element={<WebsiteMarketingPage data-id="element-51" data-mp="1xhwsj31eicxe" />} data-id="element-50" data-mp="22f6iqkwm6sma" />
              <Route path="/portfolio" element={<PortfolioPage data-id="element-53" data-mp="1thmhvd2nyyc7" />} data-id="element-52" data-mp="1the1vcb8vcws" />

              {/* Sector Routes */}
              <Route path="/sector/zakelijke-dienstverlening" element={<SectorZakelijkeDienstverleningPage data-id="element-55" data-mp="1ji59uozxw8d2" />} data-id="element-54" data-mp="1ohi7m4scmzuf" />
              <Route path="/sector/bouw-installatie" element={<SectorBouwInstallatiePage data-id="element-57" data-mp="1elew48blxout" />} data-id="element-56" data-mp="1jki15srl7v2s" />
              <Route path="/sector/makelaars-vastgoed" element={<SectorMakelaarsVastgoedPage data-id="element-59" data-mp="38xv0f3kuesx1" />} data-id="element-58" data-mp="3dwy68q8nd362" />
              <Route path="/sector/zorgpraktijken" element={<SectorZorgpraktijkenPage data-id="element-61" data-mp="3hdu6dl376ltl" />} data-id="element-60" data-mp="38viiurizykki" />
              <Route path="/sector/horeca-hospitality" element={<SectorHorecaHospitalityPage data-id="element-63" data-mp="3q6xjfs9xkwnp" />} data-id="element-62" data-mp="3lfyy2ea358dl" />
              <Route path="/sector/coaches-consultants" element={<SectorCoachesConsultantsPage data-id="element-65" data-mp="3v4z4giqx361t" />} data-id="element-64" data-mp="3q7h0z7vo5j17" />
              <Route path="/sector/lokale-retail" element={<SectorLokaleRetailPage data-id="element-67" data-mp="2yi45y2awxxht" />} data-id="element-66" data-mp="2yg14mm4b8hxs" />

              {/* Cluster Routes */}
              <Route path="/sector/zakelijke-dienstverlening/accountant" element={<ClusterAccountantPage data-id="element-69" data-mp="37iiudaj6bspj" />} data-id="element-68" data-mp="32jfojnvddigi" />
              <Route path="/cluster/kosten-website-accountant" element={<KostenWebsiteAccountantPage data-id="element-71" data-mp="mr04z74ql2jk" />} data-id="element-70" data-mp="3cgk9jkdhb7vq" />
              <Route path="/sector/bouw-installatie/bouwbedrijf" element={<ClusterBouwbedrijfPage data-id="element-73" data-mp="rr4pr9cogjfl" />} data-id="element-72" data-mp="msl4lb5wrboa" />
              <Route path="/sector/bouw-installatie/loodgieter" element={<ClusterLoodgieterPage data-id="element-75" data-mp="3t6fk7xm15kqr" />} data-id="element-74" data-mp="1zuxur6x7102" />
              <Route path="/sector/bouw-installatie/elektricien" element={<ClusterElektricienPage data-id="element-77" data-mp="bwzn4zw2bcl3" />} data-id="element-76" data-mp="3t9tq3ftwkc2y" />
              <Route path="/sector/bouw-installatie/dakdekker" element={<ClusterDakdekkerPage data-id="element-79" data-mp="3fh40l1f60p13" />} data-id="element-78" data-mp="71kb8dhm7qrb" />
              <Route path="/sector/makelaars-vastgoed/makelaar" element={<ClusterMakelaarPage data-id="element-81" data-mp="3aev783ydrkyg" />} data-id="element-80" data-mp="3fdpv3kb7fzpf" />
              <Route path="/sector/makelaars-vastgoed/projectontwikkelaar" element={<ClusterProjectontwikkelaarPage data-id="element-83" data-mp="3ke44p6sgfhpk" />} data-id="element-82" data-mp="3p6xa7wvqyu2p" />
              <Route path="/sector/makelaars-vastgoed/vastgoedbeheer" element={<ClusterVastgoedbeheerPage data-id="element-85" data-mp="2rqq5t3574c2t" />} data-id="element-84" data-mp="2wpb6t4s9uzsb" />
              <Route path="/sector/makelaars-vastgoed/woningpresentatie" element={<ClusterWoningpresentatiePage data-id="element-87" data-mp="1774j9bu63gaj" />} data-id="element-86" data-mp="2rq81dj8dqrjt" />
              <Route path="/sector/zorgpraktijken/fysiotherapie" element={<ClusterFysiotherapiePage data-id="element-89" data-mp="xarp6cupn0f9" />} data-id="element-88" data-mp="1bzfhma99eu0z" />
              <Route path="/sector/zorgpraktijken/tandarts" element={<ClusterTandartsPage data-id="element-91" data-mp="129m7zesogozd" />} data-id="element-90" data-mp="x8f07fqjbpsp" />
              <Route path="/sector/zorgpraktijken/huisarts" element={<ClusterHuisartsPage data-id="element-93" data-mp="1uyjqnj0swnsn" />} data-id="element-92" data-mp="1pynkpe8jmmag" />
              <Route path="/sector/zorgpraktijken/psycholoog" element={<ClusterPsycholoogPage data-id="element-95" data-mp="1gxpecpamu2op" />} data-id="element-94" data-mp="1ux8kxdnsp5yw" />
              <Route path="/sector/horeca-hospitality/restaurant" element={<ClusterRestaurantPage data-id="element-97" data-mp="5jburwmww9eh" />} data-id="element-96" data-mp="1kzaz0wterl9g" />
              <Route path="/sector/horeca-hospitality/hotel-bb" element={<ClusterHotelBbPage data-id="element-99" data-mp="9m8hnzjhiro8" />} data-id="element-98" data-mp="5hsg2agwm6et" />
              <Route path="/sector/horeca-hospitality/cafe-lunchroom" element={<ClusterCafeLunchroomPage data-id="element-101" data-mp="l1d6ju0swbby" />} data-id="element-100" data-mp="psbpz2h35pjf" />
              <Route path="/sector/horeca-hospitality/afhaal-bezorg" element={<ClusterAfhaalBezorgPage data-id="element-103" data-mp="g29zk419fv1c" />} data-id="element-102" data-mp="kzs9nxr0kgax" />
              <Route path="/sector/coaches-consultants/coaching" element={<ClusterCoachingPage data-id="element-105" data-mp="18r7im9dapvv5" />} data-id="element-104" data-mp="b3p1aa5kjlfj" />
              <Route path="/sector/coaches-consultants/consultant" element={<ClusterConsultantPage data-id="element-107" data-mp="13se2082ppoqr" />} data-id="element-106" data-mp="18olbuby8bkdz" />
              <Route path="/sector/coaches-consultants/sportschool" element={<ClusterSportschoolPage data-id="element-109" data-mp="urg1hzrhfzcx" />} data-id="element-108" data-mp="yrqdpu5vbm08" />
              <Route path="/sector/coaches-consultants/personal-trainer" element={<ClusterPersonalTrainerPage data-id="element-111" data-mp="3jgmlf53paga9" />} data-id="element-110" data-mp="uszi5rh1wcf8" />
              <Route path="/sector/lokale-retail/kapsalon" element={<ClusterKapsalonPage data-id="element-113" data-mp="1uzw72lbz0bk2" />} data-id="element-112" data-mp="3fgcd3lsfrds8" />
              <Route path="/sector/lokale-retail/fietsenwinkel" element={<ClusterFietsenwinkelPage data-id="element-115" data-mp="1yylt12b2r1fb" />} data-id="element-114" data-mp="1ux9x6f1lxjyo" />
              <Route path="/sector/lokale-retail/garage" element={<ClusterGaragePage data-id="element-117" data-mp="28r15xl7ikztc" />} data-id="element-116" data-mp="23yq8qq45rs4h" />
              <Route path="/sector/lokale-retail/autobedrijf" element={<ClusterAutobedrijfPage data-id="element-119" data-mp="2dpb66a83iqlt" />} data-id="element-118" data-mp="28skpbkogvqzc" />

              {/* New high-intent routes */}
              <Route path="/accountant-amsterdam" element={<AccountantAmsterdamPage data-id="element-121" data-mp="2mrkdkr82i3uz" />} data-id="element-120" data-mp="2imul7ccmb7et" />
              <Route path="/financieel-adviseur-amsterdam" element={<FinancieelAdviseurAmsterdamPage data-id="element-123" data-mp="sc9fhdtxi2mo" />} data-id="element-122" data-mp="2rp3qnnt14alc" />

              {/* Local SEO routes */}
              <Route path="/webdesign-alkmaar" element={<WebdesignAlkmaarPage data-id="element-125" data-mp="xdfajib2a1zd" />} data-id="element-124" data-mp="xbciytu9g0sj" />
              <Route path="/webdesign-heerhugowaard" element={<WebdesignHeerhugowaardPage data-id="element-127" data-mp="1vnf8bi6t7xzy" />} data-id="element-126" data-mp="20lgre348jxbf" />
              <Route path="/webdesign-hoorn" element={<WebdesignHoornPage data-id="element-129" data-mp="29ng6uqzlqtc9" />} data-id="element-128" data-mp="1vp8eyxhfai7y" />
              <Route path="/webdesign-schagen" element={<WebdesignSchagenPage data-id="element-131" data-mp="24nkb1f12687s" />} data-id="element-130" data-mp="29ohurw1pvabe" />
              <Route path="/webdesign-den-helder" element={<WebdesignDenHelderPage data-id="element-133" data-mp="2jj9ryyrdzv5n" />} data-id="element-132" data-mp="24q6izfrv2pqj" />
              <Route path="/webdesign-dijk-en-waard" element={<WebdesignDijkEnWaardPage data-id="element-135" data-mp="2sd6bs6x2wvhw" />} data-id="element-134" data-mp="2emt485o3nit3" />
              <Route path="/webdesign-castricum" element={<WebdesignCastricumPage data-id="element-137" data-mp="2ocvvo1fkoopb" />} data-id="element-136" data-mp="2scmt2nzlu32t" />
              <Route path="/webdesign-heiloo" element={<WebdesignHeilooPage data-id="element-139" data-mp="32bvmnfqk5fon" />} data-id="element-138" data-mp="32bltxke4ouf9" />
              <Route path="/webdesign-uitgeest" element={<WebdesignUitgeestPage data-id="element-141" data-mp="3gykgp221j0nn" />} data-id="element-140" data-mp="2xdaix6c3kdvg" />
              <Route path="/webdesign-bergen" element={<WebdesignBergenPage data-id="element-143" data-mp="3lwcjir48476m" />} data-id="element-142" data-mp="3gyubd2y15vzo" />
              <Route path="/webdesign-purmerend" element={<WebdesignPurmerendPage data-id="element-145" data-mp="36zv9q4bon0m6" />} data-id="element-144" data-mp="3lv1g4seox1g1" />
              <Route path="/webdesign-haarlem" element={<WebdesignHaarlemPage data-id="element-147" data-mp="2y7tceewwu0g4" />} data-id="element-146" data-mp="3byexma9u6mh6" />
              <Route path="/webdesign-zaanstad" element={<WebdesignZaanstadPage data-id="element-149" data-mp="32yrwzqoxlkp6" />} data-id="element-148" data-mp="2y68hupalihi9" />
              <Route path="/webdesign-haarlemmermeer" element={<WebdesignHaarlemmermeerPage data-id="element-151" data-mp="2obgibfxgdkku" />} data-id="element-150" data-mp="330cr5f7c31mi" />
              <Route path="/webdesign-amsterdam" element={<WebdesignAmsterdamPage data-id="element-153" data-mp="2f97bp15b2bcq" />} data-id="element-152" data-mp="2t9rsxsvknz44" />
              <Route path="/webdesign-amstelveen" element={<WebdesignAmstelveenPage data-id="element-155" data-mp="2j9922e5lbicp" />} data-id="element-154" data-mp="2f9qqi8znsjmj" />
              <Route path="/webdesign-hilversum" element={<WebdesignHilversumPage data-id="element-157" data-mp="2znyxb44eocn6" />} data-id="element-156" data-mp="2zpry42sc82n9" />
              <Route path="/webdesign-huizen" element={<WebdesignHuizenPage data-id="element-159" data-mp="2prcgqrj447qy" />} data-id="element-158" data-mp="2us032zwec0eu" />
              <Route path="/webdesign-gooise-meren" element={<WebdesignGooiseMerenPage data-id="element-161" data-mp="2krzjrdyj1kan" />} data-id="element-160" data-mp="2pq14027ovpnp" />
              <Route path="/webdesign-velsen" element={<WebdesignVelsenPage data-id="element-163" data-mp="2gt0hk146k1mw" />} data-id="element-162" data-mp="2gqxk4w0p7685" />
              <Route path="/webdesign-beverwijk" element={<WebdesignBeverwijkPage data-id="element-165" data-mp="270uqctlr5o8r" />} data-id="element-164" data-mp="2bzfq6rx3e5wo" />
              <Route path="/webdesign-heemskerk" element={<WebdesignHeemskerkPage data-id="element-167" data-mp="223m4ahxhh028" />} data-id="element-166" data-mp="26z9vt3zfu5aw" />
              <Route path="/webdesign-texel" element={<WebdesignTexelPage data-id="element-169" data-mp="1x1wvza1nb0hu" />} data-id="element-168" data-mp="1x2yh67cdl3da" />
              <Route path="/webdesign-medemblik" element={<WebdesignMedemblikPage data-id="element-171" data-mp="1t2ekf4vps1ro" />} data-id="element-170" data-mp="1x5158ltywmfd" />
              <Route path="/webdesign-enkhuizen" element={<WebdesignEnkhuizenPage data-id="element-173" data-mp="cl5vfepa3xl3" />} data-id="element-172" data-mp="8kc56eod66p1" />
              <Route path="/webdesign-stede-broec" element={<WebdesignStedeBroecPage data-id="element-175" data-mp="hlacp6y0gwcd" />} data-id="element-174" data-mp="cjkxrg7o3yj0" />
              <Route path="/webdesign-drechterland" element={<WebdesignDrechterlandPage data-id="element-177" data-mp="mh93t2aq4sgh" />} data-id="element-176" data-mp="mjbr3ekhs7hi" />
              <Route path="/webdesign-koggenland" element={<WebdesignKoggenlandPage data-id="element-179" data-mp="3pzivjnaqe8rc" />} data-id="element-178" data-mp="3l20k9q98rhg6" />
              <Route path="/webdesign-opmeer" element={<WebdesignOpmeerPage data-id="element-181" data-mp="3uydfiskfq3d1" />} data-id="element-180" data-mp="3pxzg1ywwg1qm" />
              <Route path="/webdesign-hollands-kroon" element={<WebdesignHollandsKroonPage data-id="element-183" data-mp="3man9x2ocdf5" />} data-id="element-182" data-mp="3k7mqj3wb1w6" />
              <Route path="/webdesign-edam-volendam" element={<WebdesignEdamVolendamPage data-id="element-185" data-mp="378ss9xh90jxy" />} data-id="element-184" data-mp="329oltelpl0bb" />
              <Route path="/webdesign-waterland" element={<WebdesignWaterlandPage data-id="element-187" data-mp="2h0geyvvnuxex" />} data-id="element-186" data-mp="377818hu57j4u" />
              <Route path="/webdesign-landsmeer" element={<WebdesignLandsmeerPage data-id="element-189" data-mp="27yz0tj1td5sv" />} data-id="element-188" data-mp="2lz03n41n2naz" />
              <Route path="/webdesign-oostzaan" element={<WebdesignOostzaanPage data-id="element-191" data-mp="2bzj0at9v0li6" />} data-id="element-190" data-mp="27yfnkfn3z5l6" />
              <Route path="/webdesign-wormerland" element={<WebdesignWormerlandPage data-id="element-193" data-mp="1y7ulujc51ky1" />} data-id="element-192" data-mp="1y95sqs0vr8td" />
              <Route path="/webdesign-bloemendaal" element={<WebdesignBloemendaalPage data-id="element-195" data-mp="1ob9jy6vf0pyf" />} data-id="element-194" data-mp="2305rm2tk80yi" />
              <Route path="/webdesign-heemstede" element={<WebdesignHeemstedePage data-id="element-197" data-mp="1taui4f2rgua3" />} data-id="element-196" data-mp="1ocsz1u5c4uym" />
              <Route path="/webdesign-zandvoort" element={<WebdesignZandvoortPage data-id="element-199" data-mp="1fce9ujp92vpu" />} data-id="element-198" data-mp="1fajr9c1gbfox" />
              <Route path="/webdesign-aalsmeer" element={<WebdesignAalsmeerPage data-id="element-201" data-mp="10n2vdx5s30r7" />} data-id="element-200" data-mp="1k8cvhzj71zmk" />
              <Route path="/webdesign-uithoorn" element={<WebdesignUithoornPage data-id="element-203" data-mp="vpt8op9rx372" />} data-id="element-202" data-mp="10pp2xwso5g9f" />
              <Route path="/webdesign-ouder-amstel" element={<WebdesignOuderAmstelPage data-id="element-205" data-mp="19ly35doh0iwm" />} data-id="element-204" data-mp="19o13orn91ufl" />
              <Route path="/webdesign-diemen" element={<WebdesignDiemenPage data-id="element-207" data-mp="1jlx9d3xf3x6b" />} data-id="element-206" data-mp="15lwblxcg95v2" />
              <Route path="/webdesign-blaricum" element={<WebdesignBlaricumPage data-id="element-209" data-mp="1emkqeu9o3a90" />} data-id="element-208" data-mp="1jkdvfjz8hy7p" />
              <Route path="/webdesign-laren" element={<WebdesignLarenPage data-id="element-211" data-mp="1tays31vcksnz" />} data-id="element-210" data-mp="1tc0d9z62uvjf" />
              <Route path="/webdesign-wijdemeren" element={<WebdesignWijdemerenPage data-id="element-213" data-mp="1odyuzggh7090" />} data-id="element-212" data-mp="1te31cdno6eli" />

              <Route path="/alle-locaties" element={<AlleLocatiesPage data-id="element-215" data-mp="22d80nm722byq" />} data-id="element-214" data-mp="22c6plhq1hph0" />
              <Route path="*" element={<NotFoundPage data-id="element-217" data-mp="1xen0tnvptuat" />} data-id="element-216" data-mp="1xe55ctgvnk3y" />
            </Routes>
          </Suspense>
        </div>
        <Footer data-id="element-218" data-mp="v0z57x150h26" />
        <CookieConsent data-id="element-219" data-mp="v1iekpcq1x4l" />
      </div>
    </BrowserRouter>;
}